import React, { useState } from "react";
import Notification from "../components/Notification";

export const NotificationContext = React.createContext({});

export const NotificationProvider = ({ initial, children }) => {
  const [notifications, setNotifications] = useState(initial || []);

  const value = {
    setNotifications,
  };

  return (
    <NotificationContext.Provider value={value}>
      {/* Global notification live region, render this permanently at the end of the document */}
      <div
        aria-live="assertive"
        className="fixed z-50 inset-0 flex items-end px-4 py-6 pointer-events-none lg:p-6 lg:pt-20 lg:items-start"
      >
        <div className="w-full flex flex-col items-center space-y-4 lg:items-end">
          {notifications.map((notification, index) => (
            <Notification key={index} delay={250 * index} {...notification} />
          ))}
        </div>
      </div>
      {children}
    </NotificationContext.Provider>
  );
};

export const useNotifications = () => {
  const { setNotifications } = React.useContext(NotificationContext);
  return {
    addNotification: (notification) => {
      setNotifications((notifications) => [...notifications, notification]);
    },
  };
};
